module.exports = __webpack_public_path__ + "static/img/11.c56b80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/11.png
// module id = oNfB
// module chunks = 0